import * as React from 'react';

// @ts-ignore
import Checkbox from 'components/Checkbox';
import Field from 'components/Field';
import Label from 'components/Label';

type Props = {
  handleIncludeStudentsChange: (includeStudents: boolean) => void;
  handleIncludeParentsChange: (includeParents: boolean) => void;
  includeStudents: boolean;
  includeParents: boolean;
};

export default function AdminNewAutoMessageComposeRecipients(props: Props) {
  const { includeStudents, includeParents } = props;
  return (
    <Field>
      <Label>Message recipients</Label>
      <Checkbox
        onChange={() => props.handleIncludeStudentsChange(!includeStudents)}
        label="Students"
        checked={includeStudents}
      />
      <Checkbox
        onChange={() => props.handleIncludeParentsChange(!includeParents)}
        label="Parents and guardians"
        checked={includeParents}
      />
    </Field>
  );
}
